export default __webpack_public_path__ + "static/6-c981725cbcb085063d846f5cf1da6869.png";